var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJetskiHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29430",
    "data-name": "Group 29430",
    transform: "translate(-156.999 -502.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(156.999 502.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29423",
    "data-name": "Group 29423",
    transform: "translate(11.597 -2.613)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50912",
    "data-name": "Path 50912",
    d: "M22.666,269.291a.084.084,0,0,0-.086-.084c-1.331.022-1.36.547-2.748.547-1.417,0-1.417-.547-2.833-.547s-1.417.547-2.833.547-1.417-.547-2.833-.547-1.417.547-2.833.547-1.417-.547-2.833-.547-1.417.547-2.833.547c-1.387,0-1.416-.525-2.747-.547a.084.084,0,0,0-.086.084v8.474a.084.084,0,0,0,.084.084h22.5a.084.084,0,0,0,.084-.084v-8.474Z",
    transform: "translate(160.589 251.848)",
    fill: "#d3effb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29422",
    "data-name": "Group 29422"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50814",
    "data-name": "Path 50814",
    d: "M291.717,70.747l1.477.852s1.724-.6,2.314-.258l-2.8-1.617A11.642,11.642,0,0,1,291.717,70.747Z",
    transform: "translate(-118.214 442.498)",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50815",
    "data-name": "Path 50815",
    d: "M135.608,199.753l-.746-1.37-.639.171a.921.921,0,0,0-.683.89v.979Z",
    transform: "translate(32.96 319.535)",
    fill: "#dd636e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50816",
    "data-name": "Path 50816",
    d: "M176.277,102.782l-1.979-1.142-.927-.01-.506-.818a1.881,1.881,0,0,0-1.9.013l-2.06,1.227-1.247,1.126s-4.261.758-4.261.758v2.64l12.836-3.439A.194.194,0,0,0,176.277,102.782Z",
    transform: "translate(4.429 413.028)",
    fill: "#707dd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50817",
    "data-name": "Path 50817",
    d: "M369.684,107.079l-1.433-.827-.366.634a.409.409,0,0,0,.15.558l.321.185a.876.876,0,0,0,1.2-.321Z",
    transform: "translate(-190.957 407.588)",
    fill: "#ffe07d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50818",
    "data-name": "Path 50818",
    d: "M113.975,166.073c1.417,0,1.417.547,2.833.547,1.386,0,1.416-.524,2.743-.547l6.226-1.668a2.607,2.607,0,0,0,1.843-1.843l.339-1.266-14.634,3.921.5.858Z",
    transform: "translate(52.28 354.98)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50819",
    "data-name": "Path 50819",
    d: "M127.72,161.9a2.607,2.607,0,0,1-1.764,1.6l-5.7,1.527a5.92,5.92,0,0,1-.9.164c-.973.1-1.126.524-2.368.524a3.633,3.633,0,0,1-1.566-.33l.4.7h0v.35l3.38.811,2.349-1.163,6.226-1.668a2.607,2.607,0,0,0,1.843-1.843l.339-1.266Z",
    transform: "translate(50.277 354.979)",
    fill: "#2b4d66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50820",
    "data-name": "Path 50820",
    d: "M285.473,130.27l1.666.962a.342.342,0,1,0,.342-.592l-1.568-.905-.337.2Z",
    transform: "translate(-112.246 385.146)",
    fill: "#5766cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50821",
    "data-name": "Path 50821",
    d: "M89.227,154.051a.342.342,0,0,1-.088-.673l16.111-4.32a.342.342,0,1,1,.177.661l-16.111,4.32A.342.342,0,0,1,89.227,154.051Z",
    transform: "translate(75.639 366.687)",
    fill: "#698ed5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50822",
    "data-name": "Path 50822",
    d: "M131.546,134.971a1.668,1.668,0,0,1-1.583,1.184h-.013l-4.237-.008a1.216,1.216,0,0,1-1.158-.853.417.417,0,0,1,.4-.542l5,.009a3.526,3.526,0,0,0,1.811-.5Z",
    transform: "translate(41.565 380.814)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_527",
    "data-name": "Ellipse 527",
    cx: 1.001,
    cy: 1.001,
    rx: 1.001,
    ry: 1.001,
    transform: "translate(172.49 511.242)",
    fill: "#365e7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50824",
    "data-name": "Path 50824",
    d: "M22.58,269.222a4.7,4.7,0,0,0-1.738.417v3.58a3.733,3.733,0,0,1-3.733,3.733H0v.828a.084.084,0,0,0,.084.084h22.5a.084.084,0,0,0,.084-.084v-8.474a.084.084,0,0,0-.086-.084ZM8.5,272.857a3.739,3.739,0,0,1-1.54-.3,3.072,3.072,0,0,0-1.293-.251,3.072,3.072,0,0,0-1.293.251,3.739,3.739,0,0,1-1.54.3.342.342,0,0,1,0-.684,3.073,3.073,0,0,0,1.293-.251,3.739,3.739,0,0,1,1.54-.3,3.739,3.739,0,0,1,1.54.3,3.074,3.074,0,0,0,1.293.251,3.072,3.072,0,0,0,1.293-.251,3.738,3.738,0,0,1,1.54-.3.342.342,0,0,1,0,.684,3.072,3.072,0,0,0-1.293.251,3.74,3.74,0,0,1-1.54.3Z",
    transform: "translate(160.589 251.833)",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50825",
    "data-name": "Path 50825",
    d: "M195.942,386.785a3.739,3.739,0,0,1-1.54-.3,3.463,3.463,0,0,0-2.587,0,4.145,4.145,0,0,1-3.08,0,3.462,3.462,0,0,0-2.587,0,3.738,3.738,0,0,1-1.54.3.342.342,0,0,1,0-.684,3.072,3.072,0,0,0,1.293-.251,4.145,4.145,0,0,1,3.08,0,3.463,3.463,0,0,0,2.587,0,4.146,4.146,0,0,1,3.08,0,3.074,3.074,0,0,0,1.293.251.342.342,0,0,1,0,.684Z",
    transform: "translate(-15.521 140.65)",
    fill: "#b1e4f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50826",
    "data-name": "Path 50826",
    d: "M452.539,408.425a.343.343,0,0,0,.12-.16Q452.6,408.347,452.539,408.425Z",
    transform: "translate(-271.917 118.945)",
    fill: "#90d8f9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetskiHighlighted);
export default __webpack_public_path__ + "static/media/jetskiHighlighted.afd1e0c197c740728eaf71cd05efe38e.svg";
export { ForwardRef as ReactComponent };